import React from 'react';
import './AboutUsWavyCanvas.css';

/**
 * AboutUsWavyCanvas Component
 * Canvas animation component for AboutUs page header
 * Extracted from pending_about/pending_AboutUs
 * The canvas animation is initialized by useAboutUsCanvas hook in AboutUs component
 */
const AboutUsWavyCanvas = () => {
  return (
    <div className="header-background-elements">
      <canvas id="aboutUsWavyCanvas" className="about-us-wavy-canvas"></canvas>
    </div>
  );
};

export default AboutUsWavyCanvas;

